export enum TicketStatuses {
    Open = 1,
    OnHold,
    InProgress,
    Solved,
    Closed
}
